import React from 'react'
import "./css/ProjectSettings.css"

export default function ProjectSettings() {
        return (
                <div id="main-settings-page">
                        <div id="inner-settings-container" className="container">
                                
                        </div>
                </div>
        )
}
